import { create } from "zustand";
import type { DragPayload } from "@/lib/dnd/payload";

interface DragState {
	/** 現在ドラッグ中のペイロード。ドラッグしていないときは null。 */
	payload: DragPayload | null;
	beginDrag: (payload: DragPayload) => void;
	endDrag: () => void;
}

/**
 * ドラッグ中のペイロードを保持する。dragover 中は dataTransfer の値を読めないため、
 * ドロップ可否判定やホバー表示はこのストアの payload を参照する。
 */
export const useDragStore = create<DragState>()((set) => ({
	payload: null,
	beginDrag: (payload) => set({ payload }),
	endDrag: () => set({ payload: null }),
}));
